/* eslint-disable arrow-body-style */
import http from './utils';
import {
  keyMetricsListType,
  overviewOriginType,
} from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const { CancelToken } = axios;

export const getRealtimeLanguage: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/language`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeChannel: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/channel`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeChannelStream: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/streaming_channel`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeLiveList: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<any> | any = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/live_list`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<any>;
};

export const getRealtimeOverviewMetricsStats: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/overview_metrics_stats`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeOverviewMetricsTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/overview_metrics_stats_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeRisingKeyword: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  urlParams?: string,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  urlParams,
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/rising_keyword?${urlParams}`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeSteamStats: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/pc_console_stats`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeSteamTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/pc_console_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeCommunityStats: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/community_stats`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeCommunityTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/community_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeOverviewKeyword: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/overview_keyword`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeFeedsKeyword: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/real_time/feeds_keyword`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getRealtimeOverviewMetricsStatsAndTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/overview_metrics_stats_and_stats_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeSteamStatsAndTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/pc_console_stats_and_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};

export const getRealtimeCommunityStatsAndTimeline: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  refreshTime?: number,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  refreshTime = 0,
) => {
  return http({
    url: `${prefix}/real_time/community_stats_and_timeline`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
    headers: refreshTime > 0 ? { user_cache_expire: refreshTime } : undefined,
  }) as Promise<overviewOriginType>;
};
